module.exports = __webpack_public_path__ + "img/recommend-002.843db4f6.png";